import React from 'react';

const formatDate = (value) => {
	if (!value) return '—';
	try {
		return new Date(value).toLocaleDateString();
	} catch (err) {
		return '—';
	}
};

const SubscriptionStatus = ({ subscription, onCancel, cancelling }) => {
	if (!subscription) {
		return (
			<div className="ev-admin-section ev-flat-card">
				<h3 className="ev-zero-margin">Subscription</h3>
				<p className="ev-subtle ev-top-gap">No active subscription. You are on free or per-event billing.</p>
			</div>
		);
	}

	return (
		<div className="ev-admin-section ev-flat-card">
			<h3 className="ev-zero-margin">Subscription</h3>
			<div className="ev-top-gap ev-subtle">
				<div>Status: <strong>{subscription.status}</strong></div>
				<div>Current period ends: <strong>{formatDate(subscription.currentPeriodEnd)}</strong></div>
				{subscription.graceDeadline ? (
					<div>Grace deadline: <strong>{formatDate(subscription.graceDeadline)}</strong></div>
				) : null}
			</div>
			{onCancel ? (
				<button type="button" className="ev-soft-btn ev-top-gap" onClick={onCancel} disabled={cancelling}>
					{cancelling ? 'Cancelling…' : 'Cancel Auto-Renew'}
				</button>
			) : null}
		</div>
	);
};

export default SubscriptionStatus;
